import {
  BioJsonIcon,
  Download,
  Download2D,
  Download3D,
  ForcesJsonIcon,
  CalibJsonIcon,
} from "icons";
import React from "react";
import styles from "./syles.module.scss";
import { Button, message } from "antd";
import { UseLazyApiCallV2 } from "hooks";

export const DownloadJsons = ({
  fileId,
  videoSources,
  setDownloading,
  twoDURL,
  isDesktop,
}) => {
  const downloadOptions = [
    {
      icon: Download,
      key: "video",
    },
    {
      icon: Download2D,
      key: "2d",
    },
    {
      icon: Download3D,
      key: "3d",
    },
    {
      icon: BioJsonIcon,
      key: "bio",
    },
    {
      icon: ForcesJsonIcon,
      key: "forces",
    },
    {
      icon: CalibJsonIcon,
      key: "calibJsonIcon",
    },
  ];
  const [uploadZip, { isLoading: uploadZipLoading }] = UseLazyApiCallV2({
    url: "/download_file  ",
    method: "POST",
  });
  const [downloadCalibration, { isLoading: downloadCalibrationLoading }] =
    UseLazyApiCallV2({
      url: "/get_calib_json  ",
      method: "POST",
    });
  const [deleteZip, { isLoading: deleteZipLoading }] = UseLazyApiCallV2({
    url: "/delete_file",
    method: "POST",
  });
  const [downloadZip, { isLoading: downloadZipLoading }] = UseLazyApiCallV2({
    url: "/download_zip",
    method: "POST",
  });

  const [download2DFunction] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  });

  async function handleDownload(video_url, index) {
    setDownloading(true);
    try {
      const response = await fetch(video_url);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `${fileId?.split("/")[1]}_${index + 1}.mp4`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      URL.revokeObjectURL(url);
    } catch (error) {
      // console.log({ error });
    } finally {
      setDownloading(false);
    }
  }

  async function handleDownloadJson({ purpose, file }) {
    if (!purpose || !file) return;
    // return console.log({ selectedRows });

    let zipKey;
    setDownloading(true);
    try {
      // 1️⃣ Upload
      const res = await uploadZip({
        params: { file_ids: [`${file}.json`], purposes: purpose },
      });

      if (!res || !res.key) {
        throw new Error("Upload failed or no key returned");
      }
      zipKey = res.key;

      // 2️⃣ Download
      const downloadRes = await downloadZip({ params: { uuid: zipKey } });

      if (!downloadRes?.url) {
        throw new Error("Download URL missing");
      }

      const link = document.createElement("a");
      link.href = downloadRes.url;
      link.download = "file.json"; // Adjust as needed
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success("Downloaded successfully...");

      // 3️⃣ Delay deletion so file can be fetched
      setTimeout(async () => {
        try {
          await deleteZip({ params: { uuid: zipKey } });
        } catch (deleteError) {
          console.error("Delete zip failed", deleteError);
        }
      }, 5000); // delay to allow browser download
    } catch (error) {
      console.error(error);
      message.error(error?.message || "Something went wrong");
    } finally {
      setDownloading(false);
    }
  }
  async function handleDownloadCalibJson({ purpose, file }) {
    // return;

    if (!purpose || !file) return;

    setDownloading(true);
    try {
      // 1️⃣ Upload
      const res = await downloadCalibration({
        params: { fileId: file },
      });

      // Create a link element for the first file and trigger the download
      const link1 = document.createElement("a");
      link1.href = res?.body.presigned_url;
      link1.download = "file1.json"; // Adjust the filename here if needed
      document.body.appendChild(link1);
      link1.click();
      document.body.removeChild(link1);
    } catch (error) {
      console.error(error);
      message.error(error?.message || "Something went wrong");
    } finally {
      setDownloading(false);
    }
  }

  const handleDownload2D = async () => {
    setDownloading(true);
    try {
      // First file download
      const res1 = await download2DFunction({
        url: twoDURL,
        params: {
          fileid: fileId,
        },
      });

      // Create a link element for the first file and trigger the download
      const link1 = document.createElement("a");
      link1.href = res1;
      link1.download = "file1.json"; // Adjust the filename here if needed
      document.body.appendChild(link1);
      link1.click();
      document.body.removeChild(link1);
      console.log("First file download triggered.");

      // Wait for a brief moment to ensure the first download is triggered
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Second file download
      const res2 = await download2DFunction({
        url: "/get_tracer_json",
        params: {
          fileid: fileId,
        },
      });

      // Create a link element for the second file and trigger the download
      const link2 = document.createElement("a");
      link2.href = res2;
      link2.download = "file2.json"; // Adjust the filename here if needed
      document.body.appendChild(link2);
      link2.click();
      document.body.removeChild(link2);
      console.log("Second file download triggered.");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setDownloading(false);
    }
  };

  function handleDownloadBothVideos() {
    videoSources?.forEach((videoSrc, index) => handleDownload(videoSrc, index));
  }
  function handleClickDownload(iconType) {
    if (iconType === "video") {
      return handleDownloadBothVideos();
    }
    // else if (iconType === "2d") {
    //   return handleDownload2D();
    // }
    else if (iconType === "calibJsonIcon") {
      return handleDownloadCalibJson({ purpose: iconType, file: fileId });
    } else {
      handleDownloadJson({ purpose: iconType, file: fileId });
    }
  }

  return (
    <div className={styles.iconsWrapper}>
      {downloadOptions?.map((item) => (
        <item.icon
          height={50}
          width={50}
          key={item.key}
          onClick={() => handleClickDownload(item.key)}
          style={{
            display:
              item?.key === "calibJsonIcon" && !isDesktop ? "none" : "block",
          }}
        />
      ))}
    </div>
  );
};
